import { TransactionsNumberContext } from "@state/context/account-statement/TransactionsNumberContext";
import React, { ReactNode, useState } from "react";

export default function TransactionsNumberContextProvider(props: {
	children: ReactNode;
}) {
	const [transactionsNumber, setTransactionsNumber] = useState(null);

	return (
		<TransactionsNumberContext.Provider
			value={{
				transactionsNumber: transactionsNumber,
				setTransactionsNumber,
			}}
		>
			{props.children}
		</TransactionsNumberContext.Provider>
	);
}
